import React from 'react';

import './App.css';
import { Display } from './Display';



function App() {
  
  return (
    <div style={{background:"#F5F5F5"}}>
        <Display />
    </div>
  );
}

export default App;
